var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M31.25 28.125H50V42.1875C50 44.6875 47.8125 46.875 45.3125 46.875H4.6875C2.1875 46.875 0 44.6875 0 42.1875V28.125H18.75V32.8125C18.75 33.2269 18.9146 33.6243 19.2076 33.9174C19.5007 34.2104 19.8981 34.375 20.3125 34.375H29.6875C30.1019 34.375 30.4993 34.2104 30.7924 33.9174C31.0854 33.6243 31.25 33.2269 31.25 32.8125V28.125Z",
    fill: "#828284"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3125 12.5H37.5V7.8125C37.5 5.3125 35.3125 3.125 32.8125 3.125H17.1875C14.6875 3.125 12.5 5.3125 12.5 7.8125V12.5H4.6875C2.1875 12.5 0 14.6875 0 17.1875V25H50V17.1875C50 14.6875 47.8125 12.5 45.3125 12.5ZM31.25 12.5H18.75V9.375H31.25V12.5Z",
    fill: "#828284"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.a71d7205fcbb63a0dfa7e9418ffaa549.svg";
export { ForwardRef as ReactComponent };